import { unzipSync, strFromU8 } from "fflate";
import { normalizePath } from "./utils";

const TEXT_EXTENSIONS = new Set([
  ".md",
  ".toml",
  ".json",
  ".jsonl",
  ".txt",
  ".log",
  ".py",
  ".sh",
  ".dockerfile",
  ".yaml",
  ".yml",
  ".patch",
  ".diff",
]);

const extension = (path) => {
  const name = normalizePath(path).split("/").at(-1) || "";
  if (name === "Dockerfile") return ".dockerfile";
  const index = name.lastIndexOf(".");
  return index >= 0 ? name.slice(index).toLowerCase() : "";
};

export const isTextPath = (path) => TEXT_EXTENSIONS.has(extension(path));

const readBrowserFile = async (file) => {
  const path = normalizePath(file.webkitRelativePath || file.name);
  if (file.name.toLowerCase().endsWith(".harborlens.json")) {
    const payload = JSON.parse(await file.text());
    if (!Array.isArray(payload.entries)) throw new Error("Harbor Lens bundle 缺少 entries");
    return payload.entries.map((entry) => ({
      ...entry,
      path: normalizePath(entry.path),
      source: file.name,
    }));
  }
  if (file.name.toLowerCase().endsWith(".zip")) {
    return readZip(await file.arrayBuffer(), file.name);
  }
  if (!isTextPath(path)) {
    return [{ path, kind: "binary", size: file.size, source: file.name }];
  }
  return [
    {
      path,
      kind: "text",
      size: file.size,
      text: await file.text(),
      source: file.name,
    },
  ];
};

export const readZip = (buffer, source = "archive.zip") => {
  const entries = unzipSync(new Uint8Array(buffer));
  return Object.entries(entries)
    .filter(([path]) => !path.endsWith("/"))
    .map(([rawPath, bytes]) => {
      const path = normalizePath(rawPath);
      if (!isTextPath(path)) {
        return { path, kind: "binary", size: bytes.byteLength, source };
      }
      try {
        return {
          path,
          kind: "text",
          size: bytes.byteLength,
          text: strFromU8(bytes),
          source,
        };
      } catch {
        return { path, kind: "binary", size: bytes.byteLength, source };
      }
    });
};

export const readLocalFiles = async (fileList) => {
  const nested = await Promise.all([...fileList].map(readBrowserFile));
  const byPath = new Map();
  for (const entry of nested.flat()) {
    byPath.set(normalizePath(entry.path), entry);
  }
  return [...byPath.values()].sort((a, b) => a.path.localeCompare(b.path));
};

export const readDropItems = async (dataTransfer) => {
  if (dataTransfer.files?.length) return readLocalFiles(dataTransfer.files);
  return [];
};
